<template>
  <section class="columns">
    <div class="column is-6">
      <div class="my_container" ref="copyPlaneVisual">
        <table
          border="0"
          cellspacing="0"
          cellpadding="0"
          style="
            font-family: 'Arial', sans-serif !important;
            font-size: 10px;
            font-weight: 400;
            background-color: #f7fbfc;
            border: 1px solid #dcecef;
            border-radius: 14px;
            border-collapse: separate;
            overflow: hidden;
            max-width: 480px;
            min-width: 440px;
          "
        >
          <tbody>
            <tr>
              <td style="padding: 16px 18px 0">
                <table border="0" style="margin-bottom:0;">
                  <tbody>
                    <tr>
                      <td style="text-align: center; padding: 8px 18px 8px 0; width: 100px">
                        
                          <img
                            width="76"
                            style="
                              height: 76px;
                              max-height: 76px;
                              width: 76px;
                              max-width: 76px;
                              border-radius: 100%;
                              border: 3px solid #36d1ff;
                              object-fit: cover;
                              o-object-fit: cover;
                            "
                            :src="image"
                            alt="OSFATUN"
                          /> <br />
                        <span style="display: inline-block; margin-top: 6px; font-size: 13px; font-weight: bold"
                          >{{ name }}
                          <span style="color: #00758f">{{
                            lastname
                          }}</span></span
                        >
                      </td>
                      <td style="padding-right: 12px">
                        <table border="0" style="margin-bottom: -2px">
                          <tbody>
                            <tr>
                              <td>
                                <i style="color: #64747a; font-size: 10px">{{
                                  responsability
                                }}</i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table border="0" cellspacing="0" cellpadding="4">
                          <tbody>
                            <tr>
                              <td
                                style="
                                  background: #edf1f3;
                                  text-align: center;
                                  width: 25px;
                                  height: 25px;
                                  border-radius: 7px;
                                "
                              >
                                <img
                                  src="/img/fontawesome/envelope.png"
                                  width="13"
                                />
                              </td>
                              <td>
                                <a
                                  style="
                                    color: #5d5d5d;
                                    font-weight: 700;
                                    text-decoration: none;
                                  "
                                  :href="`mailto:${email}`"
                                >
                                  {{ email }}
                                </a>
                              </td>
                            </tr>
                            <tr v-if="celphone !== ''">
                              <td
                                style="
                                  background: #edf1f3;
                                  text-align: center;
                                  width: 25px;
                                  height: 25px;
                                  border-radius: 7px;
                                "
                              >
                                <img
                                  src="/img/fontawesome/whatsapp.png"
                                  width="13"
                                />
                              </td>
                              <td>
                                <a
                                  :href="`http://wa.me/${celphone}`"
                                  style="
                                    color: #5d5d5d;
                                    font-weight: 700;
                                    text-decoration: none;
                                  "
                                >
                                  {{ celphone }}
                                </a>
                              </td>
                            </tr>
                            <tr v-if="phone !== ''">
                              <td
                                style="
                                  background: #edf1f3;
                                  text-align: center;
                                  width: 25px;
                                  height: 25px;
                                  border-radius: 7px;
                                "
                              >
                                <img
                                  src="/img/fontawesome/phone.png"
                                  width="13"
                                />
                              </td>
                              <td>
                                <a
                                  :href="`tel:${phone}`"
                                  style="
                                    color: #5d5d5d;
                                    font-weight: 700;
                                    text-decoration: none;
                                  "
                                  >{{ phone }} Int. {{ internal_phone }}</a
                                >
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="
                                  background: #edf1f3;
                                  text-align: center;
                                  width: 25px;
                                  height: 25px;
                                  border-radius: 7px;
                                "
                              >
                                <img
                                  src="/img/fontawesome/map-marker-alt.png"
                                  width="13"
                                />
                              </td>
                              <td>
                                <span
                                  style="
                                    color: #5d5d5d;
                                    font-weight: 700;
                                    text-decoration: none;
                                  "
                                >
                                  {{ delegation_address }}
                                </span>
                                <br />
                                <span style="font-size: 7px">
                                  {{ delegation_city }},
                                  {{ delegation_province }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style="padding-top: 8px; vertical-align: top">
                        <img
                          width="76px"
                          style="max-width: 76px; padding: 5px; background: #ffffff; border: 1px solid #dcecef; border-radius: 8px"
                          :src="`https://api.qrserver.com/v1/create-qr-code/?size=76x76&data=https://www.osfatun.com.ar/personal/${id}`"
                        />
                        <!-- <QR :size="90" ref="canvas" :value="value" /> -->
                      </td>
                    </tr>
                  </tbody>
                </table>

                <table border="0" cellspacing="0" cellpadding="0" style="width: 100%; margin-top: 8px; border-top: 1px solid #dcecef; table-layout: fixed">
                  <tbody>
                    <tr>
                      <td style="width: 135px; padding: 12px 10px 8px 0; vertical-align: middle">
                        <a href="https://osfatun.com.ar">
                          <img
                            style="display: block; width: 120px; height: auto"
                            src="https://crm.osfatun.com.ar/img/logo-horizontal.png"
                            width="120"
                          />
                        </a>
                      </td>
                      <td style="width: 175px; padding: 10px 6px 6px; vertical-align: middle">
                        <table border="0" cellspacing="0" cellpadding="0" style="width: 100%">
                          <tbody>
                            <tr>
                              <td style="width: 26px; height: 26px; padding: 0; background: #edf1f3; border-radius: 7px; text-align: center; vertical-align: middle">
                                <a href="https://osfatun.com.ar"><img src="/img/fontawesome/globe.png" width="13" style="display: inline-block; vertical-align: middle" /></a>
                              </td>
                              <td style="padding: 0 0 0 8px; vertical-align: middle">
                                <a href="https://osfatun.com.ar" style="color: #5d5d5d; font-size: 9px; text-decoration: none"><i>www.osfatun.com.ar</i></a>
                              </td>
                            </tr>
                            <tr><td colspan="2" style="height: 5px; font-size: 1px; line-height: 5px">&nbsp;</td></tr>
                            <tr>
                              <td style="width: 26px; height: 26px; padding: 0; background: #edf1f3; border-radius: 7px; text-align: center; vertical-align: middle">
                                <a href="tel:08006665173"><img src="/img/fontawesome/phone.png" width="13" style="display: inline-block; vertical-align: middle" /></a>
                              </td>
                              <td style="padding: 0 0 0 8px; vertical-align: middle"><i style="color: #5d5d5d; font-size: 9px">0800 666 5173</i></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td style="width: 72px; padding: 10px 0 6px 8px; vertical-align: middle">
                        <table border="0" cellspacing="0" cellpadding="0">
                          <tbody>
                            <tr>
                              <td style="width: 26px; height: 26px; padding: 0; background: #edf1f3; border-radius: 7px; text-align: center; vertical-align: middle">
                                <a href="https://facebook.com/osfatunoficial"><img src="/img/fontawesome/facebook-f.png" width="13" style="display: inline-block; vertical-align: middle" /></a>
                              </td>
                              <td style="width: 6px">&nbsp;</td>
                              <td style="width: 26px; height: 26px; padding: 0; background: #edf1f3; border-radius: 7px; text-align: center; vertical-align: middle">
                                <a href="https://instagram.com/osfatunoficial"><img src="/img/fontawesome/instagram.png" width="13" style="display: inline-block; vertical-align: middle" /></a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="3" style="padding: 8px 0 14px; color: #64747a; vertical-align: middle">
                        <img src="https://zaro.com.ar/firmas/osfatun/osfatun-eco.png" width="35" style="display: inline-block; margin-right: 6px; vertical-align: middle" />
                        <span style="font-size: 8px; vertical-align: middle">Sólo imprimir en caso que sea necesario.</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <section style="display: none">
        <article id="profile">
          <img src="/img/profile/firma-osfatun-base.jpg" alt="firma" />
          <p class="name">
            {{ name }}<span>{{ lastname }}</span>
          </p>
          <p class="role">{{ responsability }}</p>
          <ul>
            <li>{{ email }}</li>
            <li>{{ celphone }}</li>
            <li>{{ phone }}</li>
            <li>{{ delegation_address }}</li>
          </ul>
        </article>
      </section>
    </div>
    <div class="column is-6 has-text-left signature-actions">
      <b-button @click="clipboardCopyCodeMode" type="is-primary" class="signature-copy-button">
        <b-icon pack="fas" icon="code" size="is-small"></b-icon>
        Copiar código
      </b-button>
      <b-button @click="clipboardCopyVisualMode" type="is-info" outlined class="signature-copy-button is-visual">
        <b-icon pack="fas" icon="copy" size="is-small"></b-icon>
        Copiar visual
      </b-button>
      <section style="display: none">
        &nbsp;&nbsp;<br />
        <b-button @click="handleDownload" type="is-primary">
          Descargar perfil
        </b-button>
      </section>
    </div>
  </section>
</template>

<script>
import html2canvas from "html2canvas";
import QR from "./qr.vue";
export default {
  name: "SignatureProfile",
  props: {
    id: {
      type: String,
    },
    image: {
      type: String,
    },
    name: {
      type: String,
    },
    lastname: {
      type: String,
    },
    responsability: {
      type: String,
    },
    email: {
      type: String,
    },
    celphone: {
      type: String,
    },
    phone: {
      type: String,
    },
    internal_phone: {
      type: String,
    },
    value: {
      type: String,
    },
    delegation_name: {
      type: String,
    },
    delegation_city: {
      type: String,
    },
    delegation_province: {
      type: String,
    },
    delegation_address: {
      type: String,
    },
  },
  components: {
    QR,
  },
  methods: {
    clipboardCopyCodeMode() {
      let content = this.$refs.copyPlaneVisual;
      const signatureHtml = content.innerHTML.replace(
        /src="(?:https?:\/\/[^\"]+)?\/img\/fontawesome\//g,
        'src="https://crm.osfatun.com.ar/img/fontawesome/'
      );
      navigator.clipboard.writeText(signatureHtml);
    },
    clipboardCopyVisualMode() {
      let content = this.$refs.copyPlaneVisual;
      if (document.selection) {
        let range = document.body.createTextRange();
        range.moveToElementText(content);
        range.select();
      } else if (window.getSelection) {
        let range = document.createRange();
        range.selectNode(content);
        window.getSelection().empty();
        window.getSelection().addRange(range);
      }
      document.execCommand("Copy");
    },
    handleDownload() {
      // profile
      html2canvas(document.getElementById("profile"))
      .then((canvas) => {
        const urlQR = `https://api.qrserver.com/v1/create-qr-code/?size=90x90&data=https://www.osfatun.com.ar/personal/${this.id}`;
        let context = canvas.getContext("2d");

        // add profile image
        let profileImage = new Image();
            profileImage.src = this.image;
            profileImage.onload = function () {
              context.drawImage(profileImage, 35, 30);
            };
        
        // add qr image
        let qrImage = new Image();
            qrImage.src = urlQR;
            qrImage.onload = function () {
              context.drawImage(qrImage, 350, 25);
            };

        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/jpg");
        link.download = "Firma.jpg";
        link.click();
      });
    },
  },
};
</script>

<style lang="scss">
.tablesignature {
  font-family: "Arial", sans-serif;
  font-size: 8px;
  font-weight: 300;
  background: url("https://zaro.com.ar/firmas/osfatun/fondo.png");
  background-size: 622px;
  background-repeat: no-repeat;
}
.my_container {
  width: 600px;
}
.signature-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  max-width: 260px;
}
.signature-copy-button {
  width: 100%;
  min-height: 44px;
  margin: 0 !important;
}
.signature-copy-button .icon {
  margin-right: 8px;
}
.img_pos {
  position: relative;
  left: 5px;
}
#profile {
  display: block;
  width: 430px;
  position: relative;
}
#profile ul {
  margin: 0;
  padding: 0;
  list-style: none;
  position: absolute;
  top: 27px;
  right: 110px;
}
#profile p.name {
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  top: 90px;
  left: 10px;
  margin: 0;
}
#profile p.name span {
  color: #00758f;
}

#profile p.role {
  font-size: 12px;
  font-weight: bold;
  position: absolute;
  top: 0px;
  left: 135px;
  color: darkgray;
  margin: 0;
}
</style>
